import React, {FC, useEffect, useState} from 'react';
import {Box, Card, CardContent, Container} from '@mui/material';
import {useAppSelector} from '../../hooks/redux';
import {IJournalResponse} from '../../models/response/IJournalResponse';
import {JournalDaysList} from '../../components/journal/JournalDaysList';

export const Journal: FC = () => {

    const {isMobile} = useAppSelector(state => state.utils);
    const {journal} = useAppSelector(state => state.kicker);

    const [days, setDays] = useState<IJournalResponse>({});

    useEffect(() => {
        if (JSON.stringify(days) !== JSON.stringify(journal.days)) {
            setDays(journal.days);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [journal.days, days]);

    return (
        <Container maxWidth='lg' disableGutters={true}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    paddingBottom: '16px',
                    // marginLeft: '5px',
                    // marginRight: '5px'
                }}
            >
                <Box sx={{
                    transition: 'all .5s !important',
                    width: '100%',
                    maxWidth: isMobile ? '96%' : '100%',
                }}>
                    <Box sx={{mt: isMobile ? 0 : 3}}>
                        <Card sx={{
                            mt: 2,
                            paddingLeft: isMobile ? '0rem' : '1rem',
                            paddingRight: isMobile ? '0rem' : '1rem',
                            borderRadius: '0.75rem'
                        }}
                        >
                            <CardContent
                                sx={{
                                    overflowY: isMobile ? '' : 'auto',
                                    // height: isMobile ? 'calc(100vh - 88px)' : 'calc(100vh - 104px)'
                                }}
                            >
                                <JournalDaysList days={days}/>
                            </CardContent>
                        </Card>
                    </Box>
                </Box>
            </Box>
        </Container>
    )
}
